// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refHostingTypeService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refHostingTypes/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refHostingTypes/${id}`).then(handleResponse);
}

function add(refHostingType) {
    return axios.post('/refHostingTypes', refHostingType).then(handleResponse);
}

function update(refHostingType) {
    return axios.put(`/refHostingTypes/${refHostingType.refHostingTypeId}`, refHostingType).then(handleResponse);
}

function deleteEntity(refHostingType) {
    return axios.delete(`/refHostingTypes/${refHostingType.refHostingTypeId}`).then(handleResponse);
}
